var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { JobList } from 'packages/job_lists/JobList';
import { SharingSettings } from 'packages/job_lists/SharingSettings';
import { EntityBuilder } from '@decahedron/entity';
import { AccessToken } from 'packages/utilities/AccessToken';
import { AppearanceSettings } from 'packages/job_lists/AppearanceSettings';
var JobListCreateEntity = /** @class */ (function (_super) {
    __extends(JobListCreateEntity, _super);
    function JobListCreateEntity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyId = null;
        _this.published = false;
        return _this;
    }
    return JobListCreateEntity;
}(JobList));
export { JobListCreateEntity };
var JobListRepository = /** @class */ (function (_super) {
    __extends(JobListRepository, _super);
    function JobListRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = '/api/v2/job-lists';
        _this.entity = JobList;
        return _this;
    }
    JobListRepository.prototype.listForJob = function (jobId) {
        return this.getPaginated(this.url, null, { job_id: jobId });
    };
    JobListRepository.prototype.listForCompany = function (companyId) {
        return this.getPaginated(this.url, null, { company_id: companyId });
    };
    JobListRepository.prototype.createJobList = function (requestEntity) {
        return this.create(requestEntity);
    };
    JobListRepository.prototype.updateJobList = function (jobListSaveRequest) {
        var _this = this;
        return this.axios.put(this.url + "/" + jobListSaveRequest.id, jobListSaveRequest)
            .then(function (r) { return _this.responseTransformer(r); })
            .then(function (d) { return EntityBuilder.buildOne(JobList, d.data); });
    };
    JobListRepository.prototype.createOrUpdateJobList = function (jobList, companyId) {
        var _this = this;
        return this.axios.put("/companies/" + companyId + "/job-list", jobList)
            .then(function (r) { return _this.responseTransformer(r); })
            .then(function (d) { return EntityBuilder.buildOne(JobList, d.data); });
    };
    JobListRepository.prototype.getSharingSettings = function (id) {
        var _this = this;
        return this.get(this.url + "/:id/sharing-settings", { id: id })
            .then(function (response) { return EntityBuilder.buildOne(SharingSettings, _this.responseTransformer(response).data); });
    };
    JobListRepository.prototype.saveJobListSharingSettings = function (id, sharingSettings) {
        var _this = this;
        return this.axios.put(this.url + "/" + id + "/sharing-settings", sharingSettings.toSaveRequest())
            .then(function (response) { return EntityBuilder.buildOne(SharingSettings, _this.responseTransformer(response).data); });
    };
    JobListRepository.prototype.saveJobListAppearanceSettings = function (id, appearanceSettings) {
        var _this = this;
        return this.axios.put(this.url + "/" + id + "/appearance-settings", appearanceSettings.toSaveRequest())
            .then(function (response) { return EntityBuilder.buildOne(AppearanceSettings, _this.responseTransformer(response).data); });
    };
    JobListRepository.prototype.publish = function (id) {
        return this.axios.put(this.url + "/" + id + "/publish")
            .then(function () { return null; });
    };
    JobListRepository.prototype.unpublish = function (id) {
        return this.axios.put(this.url + "/" + id + "/unpublish")
            .then(function () { return null; });
    };
    JobListRepository.prototype.getAccessToken = function (jobListId) {
        var _this = this;
        return this.axios.get(this.url + "/" + jobListId + "/generate-token")
            .then(function (r) { return EntityBuilder.buildOne(AccessToken, _this.responseTransformer(r).data); });
    };
    JobListRepository.prototype.checkDomain = function (domain, subdomain) {
        if (subdomain === void 0) { subdomain = false; }
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post(this.url + "/check-domain", (_a = {},
                                _a[subdomain ? 'subdomain' : 'domain'] = domain,
                                _a))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return JobListRepository;
}(AbstractRepository));
export { JobListRepository };
